export const environment = {
    production: false,
    name: 'DEV',
    version: '3.01',
    localServer: false,
    // The scanner fleet runs against the DEV deployment — it needs the same
    // service-worker update flow as production.
    serviceWorker: true,
  };
  